import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles'; // import type { Map } from 'immutable';

var styles = {
  row: {
    backgroundColor: '#334058',
    color: 'white',
    textAlign: 'center'
  }
};

var HeaderRow = function HeaderRow(props) {
  return React.createElement("div", {
    className: "".concat(props.params.className, " ").concat(props.classes.row),
    role: "row",
    style: {
      width: props.width
    },
    "data-testid": "headerRow"
  }, props.params.columns);
};

export default withStyles(styles)(HeaderRow);